import { useEffect, useContext } from 'react';
import { useLocation } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const hasDeepLinkParams = (search) => {
  if (!search) {
    return false;
  }
  const params = new URLSearchParams(search);
  // Identifiers based on the logs provided
  const deepLinkKeys = [
    'adobe_mc',
    'appsFlyerId',
    'mboxSession',
    'idfa',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'msclkid',
    'fbclid',
    'dclid'
  ];
  return deepLinkKeys.some((key) => params.has(key));
};

export const useConditionalHomepageBeacon = (eventName) => {
  // We get the context to determine if we are in the native app or web app.
  // This is useful to know if we should trigger the homepage beacon event
  const { isConsumerApp } = useContext(ExperienceContext);
  // We get the curent path to know where the user is currently located
  // This is useful to determine if the user is directly visiting the homepage.
  const { pathname, search } = useLocation();

  useEffect(() => {

    const fullEventName = `${eventName}.page-load`;
    // If it is not the native app, we always trigger the beacon.
    if (!isConsumerApp) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger(fullEventName, 'homepage');
      return;
    }
    // In the native app, we check if it is a deep linkk
    // It is identified if the path is not the root ("/") or if it contains
    // specific tracking parameters in string
    const isConsideredDeepLink = pathname !== '/' || hasDeepLinkParams(search);

    if (!isConsideredDeepLink) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger(fullEventName, 'homepage');
    }

  }, []);
};